import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import ReviewModule from '../ReviewModule';
import './index.css';

const uuidv4 = require('uuid/v4');

export default (props) => (
  <StaticQuery
    query={graphql`
      query RecentReviews {
        allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}, limit: 5) {
          edges {
            node {
              frontmatter {
                title
                date
                author
                tags
                teaserimg {
                  childImageSharp {
                    fluid(maxWidth: 1280) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                snippet
              }
              fields {
                slug
                type
              }
              excerpt
            }
          }
        }
      }
    `}
    render={(data) => <RecentReviews data={data} props={props} />}
  />
);

const RecentReviews = ({ data, props }) => {
  const { className, sideBar } = props;
  const sortedEdges = data.allMarkdownRemark.edges;
  return (
    <div className={`${className || ''}${sideBar ? ' reviews-sidebar' : ' reviews-full'}`}>
      <h3 className="reviews-header">Recent Articles</h3>
      <ul className="container">
        {
          sortedEdges.map((val, ind) => {
            const reviewData = {
              slug: val.node.fields.slug,
              type: val.node.fields.type,
              sideBar,
              teaserimg: val.node.frontmatter.teaserimg.childImageSharp.fluid,
              title: val.node.frontmatter.title,
              tags: val.node.frontmatter.tags,
              snippet: val.node.frontmatter.snippet,
              date: val.node.frontmatter.date,
            };
            if (ind > 2 && sideBar) {
              return null;
            }
            return (
              <ReviewModule key={uuidv4()} data={reviewData} />
            );
          })
        }
      </ul>
    </div>
  );
};

RecentReviews.defaultProps = {
  props: {},
  className: '',
  sideBar: false,
};

RecentReviews.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({
          frontMatter: PropTypes.shape({
            title: PropTypes.string,
            date: PropTypes.string,
            author: PropTypes.string,
            tags: PropTypes.arrayOf(PropTypes.string),
            teaserimg: PropTypes.string,
            snippet: PropTypes.string,
          }),
          fields: PropTypes.shape({
            slug: PropTypes.string,
            type: PropTypes.string,
          }),
          excerpt: PropTypes.string,
        }),
      })),
    }),
  }).isRequired,
  props: PropTypes.shape({
    className: PropTypes.string,
    sideBar: PropTypes.bool,
  }),
  className: PropTypes.string,
  sideBar: PropTypes.bool,
};
